// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iKki","rootNoMargin":"styles_rootNoMargin__22RXg"};